<template>
  <div>
    <el-dialog title="合同信息" :visible.sync="dialog" width="1100px">
      <div class="contracts">
        <el-form ref="ruleForm" :model="formData" label-width="80px">
          <div
              :id="`contract${index+1}`"
              v-for="(contract, index) in formData.contracts"
              :key="index"
              style="margin-bottom: 10px; padding: 10px 0;"
          >
            <div style="display: flex;justify-content: space-between;padding-right: 66px">
              <div class="title-name">{{'合同'+indexToChinese(index)+'、'}}</div>
              <div><el-button @click="deleteContract(index)" type="danger" icon="el-icon-delete" circle size="mini"></el-button></div>
            </div>
            <el-row style="margin-bottom: 10px">
              <el-col :span="8">
                <!-- 修复：prop 改为点分隔格式 + 直接绑定单行规则 -->
                <el-form-item
                    label="合同主体"
                    :prop="`contracts.${index}.signContractFirstParty`"
                    :rules="[
                    { required: true, message: '请选择合同主体', trigger: 'change' }
                  ]"
                >
                  <el-select v-model="contract.signContractFirstParty" placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in contractSubjectList"
                        :key="Number(item.dictValue)"
                        :label="item.dictLabel"
                        :value="Number(item.dictValue)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    label="合同类型"
                    :prop="`contracts.${index}.contractType`"
                    :rules="[
                    { required: true, message: '请选择合同类型', trigger: 'change' }
                  ]"
                >
                  <el-select v-model="contract.contractType" placeholder="请选择" style="width: 200px">
                    <el-option
                        v-for="item in contractTypeList"
                        :key="Number(item.dictValue)"
                        :label="item.dictLabel"
                        :value="Number(item.dictValue)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                    label="合同状态"
                    :prop="`contracts.${index}.contractNumType`"
                    :rules="[
                    { required: true, message: '请选择合同状态', trigger: 'change' }
                  ]"
                >
                  <el-select v-model="contract.contractNumType" placeholder="请选择" style="width: 200px">
                    <el-option label="失效" :value="2"/>
                    <el-option label="在用" :value="1"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    label="开始日期"
                    :prop="`contracts.${index}.contractStartTime`"
                    :rules="[
                    {required: true, message: '请选择开始日期', trigger: 'change' }
                  ]"
                >
                  <el-date-picker style="width: 200px"
                                  v-model="contract.contractStartTime"
                                  type="date"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                    label="结束日期"
                    :prop="`contracts.${index}.contractEndTime`"
                    :rules="[
                    {required: true, message: '请选择结束日期', trigger: 'change' }
                  ]"
                >
                  <el-date-picker style="width: 200px"
                                  v-model="contract.contractEndTime"
                                  type="date"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div style="display:flex;justify-content: center;margin-top: 40px">
            <el-button type="danger" @click="addContract">续签合同</el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="danger" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getDictByKey} from "../../../../../api/contacts/dict";
import {updateContract,deleteContract} from "../../../../../api/contacts/user";
export default {
  name: "UpdateContract",
  data() {
    return {
      dialog:false,
      formData: {
        workId:null,
        contracts: []
      },
      userDetails:{},
      contractTypeList:[],
      contractSubjectList:[],
    }
  },
  methods: {
    addContract(){
      let item = {
        contractType:null,
        contractNumType:null,
        signContractFirstParty:null,
        contractEndTime:"",
        contractStartTime:""
      }
      this.formData.contracts.push(item);
    },
    deleteContract(index){
      let id = this.formData.contracts[index].id;
      if (id && id!=null){
        deleteContract(id).then(val=>{
          if (val.status){
            this.$emit('success');
            this.$notify.success({message: "删除成功！", offset: 40});
            this.formData.contracts.splice(index, 1);
          }else {
            this.$notify.error({message: "删除失败！", offset: 40});
          }
        });
      }else {
        this.formData.contracts.splice(index, 1)
      }
    },
    confirm(){
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {return false;}
        updateContract(this.formData).then(val=>{
          if (val.status){
            this.$emit('success');
            this.dialog = false;
            this.$notify.success({message: "更新成功！", offset: 40});
          }else {
            this.$notify.error({message: "更新失败！", offset: 40});
          }
        })
      });
    },
    openDialog(item){
      this.dialog = true;
      this.userDetails = item;
      this.formData.workId = this.userDetails.workId;
      this.formData.contracts = JSON.parse(JSON.stringify(this.userDetails.contracts));
    },
    indexToChinese(index) {
      let list = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return list[index] || `${index + 1}、`;
    },
  },
  created() {
    getDictByKey("contractType").then(val=>{
      if (val.status){this.contractTypeList = val.data;}
    })
    getDictByKey("signContractFirstParty").then(val=>{
      if (val.status){this.contractSubjectList = val.data;}
    })
  }
}
</script>

<style scoped>
.contracts{
  height: 400px;
  overflow:auto;
  margin-left: 30px;
}
.title-name{
  color: black;
  font-size: 15px;
  font-weight: 900;
  margin-bottom: 20px;
}
</style>